/**
 * SMB Component - testimonials with slider
 * @copyright 2018 AVAST Software s.r.o.
 * @author Erik Ondrus
 * @version 1.0
 * @since 2018-03
 *
 * DESCRIPTION:
 * Basic functionality of slider
 *
 * OPTIONS:
 * 
 *
 * USAGE EXAMPLE:
 * 
 */

"use strict";

$(document).ready(function () {

    //jQuery Elements
    var $testimonials = $('.js-testimonials-slider'),        
        $item = $('.js-testimonial'),

        $showPrev = $('.js-testimonials-control-left'),
        $showNext = $('.js-testimonials-control-right');    

    
    if ($testimonials.length) {
        
        //Variables
        var disabledClass = 'testimonials-slider__control_disabled',
            activeClass ='js-testimonials-active',
            itemLength = $item.length;
        
        
        $showPrev.addClass(disabledClass);                        
        $item.not('.hide').addClass(activeClass);
        
        
        $showNext.on('click', function (e) { 
            e.preventDefault();
            if (!($(this).hasClass(disabledClass)))   
            {
                var first = $item.index($item.filter('.'+activeClass+':first')) || 0;
                var next = $item.index($item.filter('.'+activeClass+':last')) + 1 || 0;

                $showPrev.removeClass(disabledClass);                        

                if (next < (itemLength)) {
                    $item.eq(first).hide().removeClass(activeClass);
                    $item.eq(next).fadeIn(70).addClass(activeClass);

                    if (next == (itemLength - 1)) {
                        $showNext.addClass(disabledClass);
                    }       
                }                  
            }
        });
        
        $showPrev.on('click', function (e) {
            e.preventDefault();
            if (!($(this).hasClass(disabledClass)))   
            {
                var last = $item.index($item.filter('.'+activeClass+':last')) || 0;
                var prev = $item.index($item.filter('.'+activeClass+':first')) - 1 || 0;

                $showNext.removeClass(disabledClass); 

                $item.eq(last).hide().removeClass(activeClass);            
                $item.eq(prev).fadeIn(70).addClass(activeClass);

                if (prev == 0) {
                    $showPrev.addClass(disabledClass); 
                }
            }
        });
    }
});